import type { TranslationSchema } from '@/core/types/translation.types';
import { registerFeatureTranslations } from '@/core/i18n';
import es from './es.json';
import en from './en.json';

export function registerAuthTranslations() {
    registerFeatureTranslations<TranslationSchema>('auth', { es, en });
}